import * as React from 'react';

import { TApplicationContext } from 'types/app-context';

const AppContext = React.createContext<TApplicationContext | undefined>(
  undefined,
);

type AppContextProviderProps = {
  appContext: any;
  children: React.ReactNode;
};

const AppContextProvider = ({
  appContext,
  children,
}: AppContextProviderProps) => {
  return (
    <AppContext.Provider value={appContext}>{children}</AppContext.Provider>
  );
};

const useAppContext = () => {
  const context = React.useContext(AppContext);

  if (!context) {
    throw new Error('useAppContext must be used within AppContextProvider');
  }

  return context;
};

export { AppContextProvider, useAppContext };
